export type DataPrivacyItem = {
  title: string;
  description: string;
};

export const DATA_PRIVACY_ITEMS: DataPrivacyItem[] = [
  {
    title: 'Your data is protected with enterprise-level security',
    description: `Our tool collects data on your skills, work habits, and goals to provide you with personalized insights and monetization opportunities. We take data privacy and security seriously and use enterprise-level security measures to ensure that your data is protected from unauthorized access.`,
  },
  {
    title: 'You have control',
    description: `With our tool, you have control over what data you choose to share and monetize. You can choose to share as much or as little data as you want, and you can revoke access to your data at any time.`,
  },
  {
    title: 'We will never use or share data that would harm you',
    description: `Our goal is to help you take control of your career and achieve your goals, not to exploit your data for profit. We will never use or share your data in a way that could harm you. We are committed to keeping your data safe, secure, and confidential.`,
  },
];
